import React from 'react';

function Option({value, children}){
    return <></>;
}

export default Option;